import React from 'react';

const SvgHr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect
        id="HR_svg__a"
        x={0}
        y={0}
        width="1em"
        height="1em"
        viewBox="0 0 28 20"
        rx={2}
      />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="HR_svg__c">
        <stop stopColor="#FF212E" offset="0%" />
        <stop stopColor="#FD0D1B" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="HR_svg__b" fill="#fff">
        <use xlinkHref="#HR_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#FF202D" mask="url(#HR_svg__b)" d="M0 0h28v6.667H0z" />
      <path
        d="M10.667 5.333l.666-.666.667.666v1.334h-1.333V5.333zm2.666 0L14 4.667l.667.666v1.334h-1.334V5.333zm2.667 0l.667-.666.666.666v1.334H16V5.333z"
        fill="#1895DB"
        opacity={0.5}
        mask="url(#HR_svg__b)"
      />
      <path
        d="M12 5.333l.667-.666.666.666v1.334H12V5.333zm2.667 0l.666-.666.667.666v1.334h-1.333V5.333z"
        fill="#191F94"
        opacity={0.5}
        mask="url(#HR_svg__b)"
      />
      <path fill="#2027AC" mask="url(#HR_svg__b)" d="M0 13.333h28V20H0z" />
      <path
        d="M13.333 6.667h1.334V8h-1.334V6.667zm2.667 0h.667L17.333 8H16V6.667zm-4.667 0H12V8h-1.333l.666-1.333zM12 8h1.333v1.333H12V8zm2.667 0H16v1.333h-1.333V8zm-1.334 1.333h1.334v1.334h-1.334V9.333zm2.667 0h1.333v1.334H16V9.333zm-1.333 1.334H16V12h-1.333v-1.333zm-4-1.334H12v1.334h-1.333V9.333zM12 10.667h1.333V12H12v-1.333zM10.667 12H12v1.333h-1.333V12zm2.666 0h1.334v1.333h-1.334V12zM16 12h1.333v1.333H16V12zm-1.333 1.333H16v1.334h-1.333v-1.334zm-2.667 0h1.333v1.334H12v-1.334z"
        fill="url(#HR_svg__c)"
        mask="url(#HR_svg__b)"
      />
    </g>
  </svg>
);

export default SvgHr;
